"use client";

import { clsx } from "@trydig/ui";
import { Checkmark } from "@/components/icons/Checkmark";
import type { InputProps } from "@/components/ui/Input";
import styles from "./Checkbox.module.css";

export interface CheckboxProps extends InputProps {
	label?: React.ReactNode;
}

export const Checkbox = ({ className, label, ...props }: CheckboxProps) => {
	return (
		<label className={clsx(styles.root, className)}>
			<div className={styles.container}>
				<input className={styles.checkbox} type="checkbox" {...props} />
				<span className={styles.checkmark}>
					<Checkmark />
				</span>
			</div>
			{label && <span className={styles.label}>{label}</span>}
		</label>
	);
};
